import { normalizeLastCustomerOrder } from "@store/slices/magentoApiSlice/utils";
import type { DeepNonNullable } from "@store/types";

import type { MagentoApiGetLastCustomerOrderQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export type LastCustomerOrder =
  DeepNonNullable<MagentoApiGetLastCustomerOrderQueryResponse["LastCustomerOrder"]> | undefined;

export const getLastCustomerOrderEndpoint = (builder: MagentoApiBuilder) => ({
  getLastCustomerOrder: builder.query<LastCustomerOrder, void>({
    query: () => ({
      method: "getLastCustomerOrder",
      params: [],
    }),
    providesTags: [TAGS.ORDER],
    transformResponse: (response: MagentoApiGetLastCustomerOrderQueryResponse) =>
      normalizeLastCustomerOrder(response.LastCustomerOrder),
  }),
});
